import i18n from '@/plugins/i18n';
import Vue from 'vue';
// import store from '@/globalvar.js'

i18n.locale = localStorage.language ? localStorage.language : i18n.locale;

const EnumService = Vue.observable({
    Titles: [
        { value: null, text: '' },
        { value: 'Mr.', text: i18n.t('ENUM.Titles.Mr') },
        { value: 'Ms.', text: i18n.t('ENUM.Titles.Ms') },
        { value: 'Mrs.', text: i18n.t('ENUM.Titles.Mrs') },
        { value: 'Dr.', text: i18n.t('ENUM.Titles.Dr') },
        { value: 'UNK', text: i18n.t('Shared.Unknown') },
        { value: 'NA', text: i18n.t('Shared.NotApplicable') },
        { value: 'DA', text: i18n.t('Shared.DeclinedToAnswer') }
    ],

    RouteNameList: [
        { value: null, text: '' },
        { value: 'Bucally', text: i18n.t('ENUM.RouteNameList.Bucally') },
        { value: 'By Mouth', text: i18n.t('ENUM.RouteNameList.ByMouth') },
        { value: 'Cervically', text: i18n.t('ENUM.RouteNameList.Cervically') }
    ],

    ActionList: [
        { value: null, text: '' },
        { value: 'Apply', text: i18n.t('ENUM.ActionList.Apply') },
        { value: 'Chew', text: i18n.t('ENUM.ActionList.Chew') },
        { value: 'Cruch', text: i18n.t('ENUM.ActionList.Cruch') }
    ],

    WhenList: [
        { value: null, text: '' },
        { value: 'AC', text: 'AC' },
        { value: 'HC', text: 'HC' },
        { value: 'PC', text: 'PC' }
    ],

    ProductTypeSelectList: [
        { value: 'G', text: i18n.t('ENUM.ProductType.PresDrug') },
        { value: 'O', text: i18n.t('Shared.OvConunter') },
        { value: 'A', text: i18n.t('ENUM.ProductType.StandAllerg') },
        { value: 'B', text: i18n.t('ENUM.ProductType.NonStandardizedAllergenic') },
        { value: 'C', text: i18n.t('ENUM.ProductType.CellularTherapy') },
        { value: 'D', text: i18n.t('ENUM.ProductType.PlasmaDerivative') },
        { value: 'V', text: i18n.t('ENUM.ProductType.Vaccine') },
        { value: 'IV', text: i18n.t('ENUM.ProductType.IvFluidTherapy') },
        { value: 'IVA', text: i18n.t('ENUM.ProductType.IvFluidTherapyAdditive') }
    ],

    SubstanceScheduleSelectList: [
        { value: 'CI', text: 'CI' },
        { value: 'CII', text: 'CII' },
        { value: 'CIII', text: 'CIII' },
        { value: 'CIV', text: 'CIV' },
        { value: 'CV', text: 'CV' }
    ],

    Relations: [
        { value: 'Self', text: 'Self' },
        { value: 'Mother', text: 'Mother' },
        { value: 'Father', text: 'Father' },
        { value: 'Brother', text: 'Brother' },
        { value: 'Sister', text: 'Sister' },
        { value: 'Wife', text: 'Wife' },
        { value: 'Husband', text: 'Husband' },
        { value: 'Son', text: 'Son' },
        { value: 'Daughter', text: 'Daughter' },
        { value: 'Other', text: 'Other' }
    ],

    PatientIdTypes: [
        { value: 'DRIVER LICENSE', text: 'DRIVER LICENSE' },
        { value: 'EMPLOYEE ID', text: 'EMPLOYEE ID' },
        { value: 'FAMILY BOOK', text: 'FAMILY BOOK' },
        { value: 'HEALTH CARD', text: 'HEALTH CARD' },
        { value: 'INSURANCE CARD', text: 'INSURANCE CARD' },
        { value: 'PASSPORT', text: 'PASSPORT' },
        { value: 'OTHER', text: 'OTHER' }
    ],

    PatientListStatus: [
        { value: true, text: i18n.t('Shared.Active'), selected: true },
        { value: false, text: i18n.t('Shared.Inactive'), selected: false },
        { value: 'All', text: i18n.t('Shared.All'), selected: false }
    ],

    Sexs: [
        { value: 'M', text: i18n.t('Shared.Male') },
        { value: 'F', text: i18n.t('Shared.Female') },
        { value: 'U', text: i18n.t('Shared.Unknown') },
        { value: 'D', text: i18n.t('Shared.DeclinedToAnswer') }
    ],

    SexsMaleFemaleOnly: [
        { value: 'M', text: i18n.t('Shared.Male') },
        { value: 'F', text: i18n.t('Shared.Female') }
    ],

    YesNoOptions: [
        { value: 'Y', text: i18n.t('Shared.TitleYes') },
        { value: 'N', text: i18n.t('Shared.TitleNo') }
    ],
    
    YesNoNotApplicableOptions: [
        { value: 'Y', text: i18n.t('Shared.TitleYes') },
        { value: 'N', text: i18n.t('Shared.TitleNo') },
        { value: 'A', text: i18n.t('Shared.NotApplicable') }
    ], 

    YesNoUnknownNotApplicableOptions: [
        { value: 'Y', text: i18n.t('Shared.TitleYes') },
        { value: 'N', text: i18n.t('Shared.TitleNo') },
        { value: 'U', text: i18n.t('Shared.Unknown') },
        { value: 'A', text: i18n.t('Shared.NotApplicable') }
    ], 

    YesNoUnknownNotApplicableDeclineToAnswerOptions: [
        { value: 'Y', text: i18n.t('Shared.TitleYes') },
        { value: 'N', text: i18n.t('Shared.TitleNo') },
        { value: 'U', text: i18n.t('Shared.Unknown') },
        { value: 'A', text: i18n.t('Shared.NotApplicable') },
        { value: 'D', text: i18n.t('Shared.DeclinedToAnswer') }
    ],

    EducationLevel: [
        { value: 'BACHELOR DEGREE', text: 'BACHELOR DEGREE' },
        { value: 'DIPLOMA', text: 'DIPLOMA' },
        { value: 'ILLITERATE', text: 'ILLITERATE' },
        { value: 'MASTERS', text: 'MASTERS' },
        { value: 'PRIMARY LEVEL', text: 'PRIMARY LEVEL' },
        { value: 'PREPARATORY LEVEL', text: 'PREPARATORY LEVEL' },
        { value: 'PHD', text: 'PHD' },
        { value: 'SECONDARY LEVEL', text: 'SECONDARY LEVEL' },
        { value: 'UNKNOWN', text: 'UNKNOWN' }
    ],

    YesNoOptionsInverted: [
        { value: 'N', text: i18n.t('Shared.TitleYes') },
        { value: 'Y', text: 'No' }
    ],

    MaritalStatus: [
        { value: 'A', text: i18n.t('ENUM.MarSt.A') },
        { value: 'D', text: i18n.t('ENUM.MarSt.D') },
        { value: 'I', text: i18n.t('ENUM.MarSt.I') },
        { value: 'L', text: i18n.t('ENUM.MarSt.L') },
        { value: 'Y', text: i18n.t('ENUM.MarSt.M') },
        { value: 'P', text: i18n.t('ENUM.MarSt.P') },
        { value: 'N', text: i18n.t('ENUM.MarSt.N') },
        { value: 'T', text: i18n.t('ENUM.MarSt.Dp') },
        { value: 'W', text: i18n.t('ENUM.MarSt.W') },
        { value: 'O', text: i18n.t('Shared.Unknown') },
        { value: 'E', text: i18n.t('Shared.NotApplicable') },
        { value: 'X', text: i18n.t('Shared.DeclinedToAnswer') }

    ],

    MaritalStatusUAE: [
        { value: 'Y', text: i18n.t('ENUM.MarSt.M') },
        { value: 'N', text: i18n.t('ENUM.MarSt.N') },
        { value: 'D', text: i18n.t('ENUM.MarSt.D') },
        { value: 'W', text: i18n.t('ENUM.MarSt.W') },
        { value: 'S', text: i18n.t('ENUM.MarSt.S') }
    ],

    Employment: [
        { value: '1', text: i18n.t('ENUM.Employment.Ft') },
        { value: '2', text: i18n.t('ENUM.Employment.Pt') },
        { value: '3', text: i18n.t('ENUM.Employment.N') },
        { value: '4', text: i18n.t('ENUM.Employment.S') },
        { value: '5', text: i18n.t('ENUM.Employment.R') },
        { value: '6', text: i18n.t('ENUM.Employment.ActM') },
        { value: '7', text: i18n.t('ENUM.Employment.H') },
        { value: '8', text: i18n.t('Shared.Unknown') },
        { value: '9', text: i18n.t('Shared.NotApplicable') },
        { value: 'A', text: i18n.t('Shared.DeclinedToAnswer') }
    ],

    EmploymentUAE: [
        { value: 'Y', text: i18n.t('Shared.TitleYes') },
        { value: 'N', text: 'No' },
        { value: 'R', text: 'Retired' }
    ],

    Student: [
        { value: 'Y', text: i18n.t('Shared.TitleYes') },
        { value: 'N', text: 'No' },
        { value: 'F', text: i18n.t('ENUM.Employment.Ft') },
        { value: 'P', text: i18n.t('ENUM.Employment.Pt') },
        { value: 'U', text: i18n.t('Shared.Unknown') },
        { value: 'A', text: i18n.t('Shared.NotApplicable') },
        { value: 'D', text: i18n.t('Shared.DeclinedToAnswer') }            

    ],

    AcceptAssign: [
        { value: null, text: '' },
        { value: 'C', text: i18n.t('ENUM.AcceptAssign.C') },
        { value: 'S', text: i18n.t('ENUM.AcceptAssign.S') },
        { value: 'M', text: i18n.t('ENUM.AcceptAssign.M') },
        { value: 'B', text: i18n.t('ENUM.AcceptAssign.b') },
        { value: 'P', text: i18n.t('ENUM.AcceptAssign.p') }
    ],

    InfoRelease: [
        { value: null, text: '' },
        { value: 'Y', text: i18n.t('ENUM.InfoRelease.Y') },
        { value: 'M', text: i18n.t('ENUM.InfoRelease.M') },
        { value: 'N', text: i18n.t('ENUM.InfoRelease.N') }
    ],

    ClaimDocIndList: [
        { value: '3', text: i18n.t('PatientClaimList.OnFileatProviderSite') },
        { value: '4', text: i18n.t('PatientClaimList.OnFileatPayorSite') },
        { value: '5', text: i18n.t('PatientClaimList.CertificationRecordinthisClaim') },
        { value: '6', text: i18n.t('PatientClaimList.NarrativeRecordIncludedwiththisClaim') },
        { value: '9', text: i18n.t('PatientClaimList.NoDocumentation') }
    ],

    PatientItems: [
        { value: 'PatientSearch', text: i18n.t('Shared.PatientList') },
        { value: 'PatientSummary', text: i18n.t('Shared.Summary') },
        { value: 'Admission', text: i18n.t('Shared.AdmissionsHeader') },
        { value: 'Appointments', text: i18n.t('Shared.Appointments') },
        { value: 'PatientAllergy', text: i18n.t('ENUM.PITEMS.PatientAllergy') },
        { value: 'PatientAsam', text: i18n.t('Shared.ASAM') },
        { value: 'CHARTREVIEWPATIENT', text: i18n.t('ENUM.PITEMS.CHARTREVIEWPATIENT') },
        { value: 'PatientContact', text: i18n.t('Shared.PatientContact') },
        { value: 'Diagnosis', text: i18n.t('Shared.Diagnoses') },
        { value: 'PatientDocument', text: i18n.t('Shared.Documents') },
        { value: 'PatientInsurance', text: i18n.t('Shared.PatientInsurance') },
        { value: 'PatientInfo', text: i18n.t('Shared.PatientInformationHeader') },
        { value: 'PRESCREENING', text: i18n.t('ENUM.PITEMS.PRESCREENING') },
        { value: 'SchedulerPatient', text: i18n.t('Shared.SchedulerNotes') },
        {
            value: 'PatientSpecialPrecautions',
            text: i18n.t('Shared.PatientSpecialPrecautions')
        },
        { value: 'PatientMarsAlerts', text: i18n.t('Shared.PatientMarsAlerts') },
        { value: 'PatientDischarges', text: i18n.t('Shared.DischargesHeader') },
        { value: 'PatientAlerts', text: i18n.t('Shared.Alerts') },
        { value: 'PatientActivities', text: i18n.t('Shared.ActivitiesHeader') },
        { value: 'patientclaimList', text: i18n.t('Shared.Claim') },
        { value: 'patientLabels', text: i18n.t('Patient.PatientLabels') },
        { value: 'PatientLetters', text: i18n.t('ENUM.PITEMS.Letters') },
        { value: 'Lab', text: i18n.t('ELab') },
        { value: 'PatientNotices', text: i18n.t('Shared.Notices') }
    ],

    ClinicalItems: [
        { value: 'PatientListClinical', text: i18n.t('Shared.ADMISSIONLIST') },
        { value: 'ClinicalSummary', text: i18n.t('Shared.Summary') },
        { value: 'ADMISSIONINFOCLINICAL', text: i18n.t('Shared.Admission') },
        { value: 'AllergyClinical', text: i18n.t('ENUM.PITEMS.PatientAllergy') },
        { value: 'ClinicalAppointments', text: i18n.t('Shared.Appointments') },
        { value: 'ClinicalAsam', text: i18n.t('Shared.ASAM') },
        { value: 'CHARTREVIEWCLINICAL', text: i18n.t('ENUM.PITEMS.CHARTREVIEWPATIENT') },
        { value: 'ClinicalNotes', text: i18n.t('Shared.ClinicalNotesHeader') },
        { value: 'ContactClinical', text: i18n.t('Shared.PatientContact') },
        { value: 'DailyNotes', text: i18n.t('Shared.DailyNotes') },
        { value: 'DiagnosisClinical', text: i18n.t('Shared.Diagnoses') },
        { value: 'Discharge', text: i18n.t('Shared.Discharge') },
        { value: 'DocumentClinical', text: i18n.t('Shared.Documents') },
        { value: 'ePharmacyClinical', text: i18n.t('Shared.ePrescribing') },
        { value: 'InsuranceClinical', text: i18n.t('Shared.PatientInsurance') },
        { value: 'LogNotes', text: i18n.t('Shared.LogNotes') },
        { value: 'Medications', text: i18n.t('Shared.Medications') },
        { value: 'PatientInfo', text: i18n.t('Shared.PatientInformationHeader') },
        { value: 'SchedulerClinical', text: i18n.t('Shared.SchedulerNotes') },
        { value: 'Transfer', text: i18n.t('Shared.Transfer') },
        { value: 'TreatmentPlanClinical', text: i18n.t('Shared.TP') },
        //{value:'WYTREATMENTPLAN',text:i18n.t('ENUM.CITEMS.WyTplan')},
        //{value:'MDTREATMENTPLAN',text:i18n.t('ENUM.CITEMS.MdTplan')},
        { value: 'ClinicalVitalSign', text: i18n.t('Shared.ClinicalVitalSign') },
        { value: 'patientLabels', text: i18n.t('Patient.PatientLabels') },
        {
            value: 'ClinicalSpecialPrecautions',
            text: i18n.t('Shared.PatientSpecialPrecautions')
        },
        { value: 'ClinicalMarsAlerts', text: i18n.t('Shared.PatientMarsAlerts') },
        { value: 'ClinicalAlerts', text: i18n.t('Shared.Alerts') },
        { value: 'ClinicalActivities', text: i18n.t('Shared.ActivitiesHeader') },
        { value: 'Orders', text: i18n.t('Shared.Orders') },
        { value: 'ClinicalLetters', text: i18n.t('Shared.FormGeneration') },
        { value: 'pSSClinical', text: i18n.t('ENUM.CITEMS.TResults') },
        { value: 'MarsClinical', text: i18n.t('ENUM.CITEMS.MarsClinical') },
        { value: 'Lab', text: i18n.t('ELab') },
        { value: 'TestOrders', text: i18n.t('Shared.TestOrders') }
    ],
    AppointmentItems: [
        { value: 'AppointmentList', text: i18n.t('ENUM.ApooItems.AppoList') },
        { value: 'SchedulerSummary', text: i18n.t('Shared.Summary') },
        { value: 'Admission', text: i18n.t('Shared.AdmissionsHeader') },
        { value: 'PatientAllergy', text: i18n.t('ENUM.PITEMS.PatientAllergy') },
        { value: 'Appointment', text: i18n.t('ENUM.PITEMS.Appointment') },
        { value: 'PatientAsam', text: i18n.t('Shared.ASAM') },
        //{value:'CancelAppt',text:i18n.t('Shared.Cancel')},
        { value: 'CHARTREVIEWPATIENT', text: i18n.t('ENUM.PITEMS.CHARTREVIEWPATIENT') },
        //{value:'ConfirmAppt',text:i18n.t('Shared.Confirm')},
        { value: 'PatientContact', text: i18n.t('Shared.PatientContact') },
        { value: 'Diagnosis', text: i18n.t('Shared.Diagnoses') },
        { value: 'Discharge', text: i18n.t('Shared.Discharges') },
        { value: 'PatientDocument', text: i18n.t('Shared.Documents') },
        { value: 'ePharmacyClinical', text: i18n.t('Shared.ePrescribing') },
        { value: 'Medications', text: i18n.t('Shared.Medications') },
        { value: 'AppointmentInsurance', text: i18n.t('Shared.PatientInsurance') },
        { value: 'PatientInfo', text: i18n.t('Shared.PatientInformationHeader') },
        { value: 'SchedulerNotes', text: i18n.t('Shared.SchedulerNotes') },
        { value: 'Transfer', text: i18n.t('Shared.Transfer') },
        //{value:'ShowUpAppt',text:i18n.t('Shared.ShowUp')},
        { value: 'PatientActivities', text: i18n.t('Shared.ActivitiesHeader') },
        { value: 'TreatmentPlanScheduler', text: i18n.t('Shared.TP') },
        { value: 'appointmentDBVital', text: i18n.t('Shared.ClinicalVitalSign') },
        {
            value: 'appointmentDBSpecialPrecautions',
            text: i18n.t('Shared.PatientSpecialPrecautions')
        },
        { value: 'patientLabels', text: i18n.t('Patient.PatientLabels') },
        { value: 'PatientMarsAlerts', text: i18n.t('Shared.PatientMarsAlerts') },
        { value: 'PatientAlerts', text: i18n.t('Shared.Alerts') },
        { value: 'Orders', text: i18n.t('Shared.Orders') },
        { value: 'PatientLetters', text: i18n.t('ENUM.PITEMS.Letters') },
        { value: 'appointmentDBpSSClinical', text: i18n.t('ENUM.CITEMS.TResults') },
        { value: 'Lab', text: i18n.t('ELab') },
        { value: 'TestOrders', text: i18n.t('Shared.TestOrders') }
    ],

    SchedulerNotesShow: [
        { value: 'ShowAllType', text: i18n.t('ENUM.ScheNotesShow.ShowAllType') },
        { value: 'ShowAllNote', text: i18n.t('ENUM.ScheNotesShow.ShowAllNote') }
    ],
    ClaimBatchItems: [
        { value: 'ClaimBatchList', text: i18n.t('ENUM.ClaimBaItems.ClaimBaList') },
        { value: 'PatientInfoClaimBatch', text: i18n.t('Shared.PatientInformationHeader') },
        { value: 'DiagnosisWorksSheet', text: i18n.t('ENUM.ClaimBaItems.DiagWorksSheet') },
        { value: 'Doctors', text: i18n.t('Shared.Doctors') },
        { value: 'Insurances', text: i18n.tc('Shared.Insurance', 2) }
    ],

    // Clinical Dashboard Filter
    Types: [
        { value: true, name: i18n.t('Shared.Inpatient') },
        { value: false, name: i18n.t('Shared.Outpatient') },
        { value: '', name: i18n.t('Shared.All') }
    ],
    Status: [
        { value: 'Active', name: i18n.t('Shared.Active') },
        { value: 'Transfer', name: i18n.t('Shared.Transfer') },
        { value: 'Inactive', name: i18n.t('Shared.Inactive') },
        { value: '', name: i18n.t('Shared.All') }
    ],
    ClinicalMedicatiosRxStatus: [
        { value: 'All', name: i18n.t('Shared.All') },
        { value: 'ActiveDuration', name: i18n.t('Shared.ActDuration') },
        { value: 'Active', name: i18n.t('Shared.Active') },
        { value: 'Inactive', name: i18n.t('Shared.Inactive') },
        { value: 'Past', name: i18n.t('Shared.Past') },
        { value: 'Expired', name: i18n.t('Shared.Expired') }
    ],
    Asam: [
        { value: 'true', name: i18n.t('ENUM.Asam.W') },
        { value: 'false', name: i18n.t('ENUM.Asam.N') },
        { value: '', name: i18n.t('Shared.All') }
    ],
    TreatmentPlan: [
        { value: true, name: i18n.t('ENUM.TreatmentPlan.W') },
        { value: false, name: i18n.t('ENUM.TreatmentPlan.N') },
        { value: '', name: i18n.t('Shared.All') }
    ],
    Program: [
        { name: i18n.t('ENUM.Program.P1') },
        { name: i18n.t('ENUM.Program.P2') },
        { name: i18n.t('ENUM.Program.P3') },
        { name: i18n.t('ENUM.Program.P4') }
    ],
    Therapies: [
        { value: 'A', name: i18n.t('ChartReview.Admissions') },
        { value: 'B', name: i18n.t('Shared.TherapiesDischargeInformation') },
        { value: 'C', name: i18n.t('Shared.GroupNotes') },
        { value: 'D', name: i18n.t('Shared.TherapiesNursing') },
        { value: 'E', name: i18n.t('Shared.TherapiesMiscellanous') },
        { value: 'F', name: i18n.t('Shared.TherapiesIntakeForms') }
    ],
    YesNoOptionsNumericThree: [
        { value: '1', text: i18n.t('Shared.TitleYes') },
        { value: '0', text: i18n.t('Shared.TitleNo') },
        { value: '2', text: i18n.t('Shared.NotApplicable')},
        { value: '3', text: i18n.t('Shared.Unknown')}
    ],

    YesNoOptionsNumericTwo: [
        { value: '1', text: i18n.t('Shared.TitleYes') },
        { value: '0', text: i18n.t('Shared.TitleNo') }
    ],

    NoteTypes: [
        { value: 'A', name: i18n.t('ENUM.NoteTypes.AA') },
        { value: 'B', name: i18n.t('ENUM.NoteTypes.AO') },
        { value: 'C', name: i18n.t('ENUM.NoteTypes.AOF') },
        { value: 'D', name: i18n.t('ENUM.NoteTypes.CF') },
        { value: 'E', name: i18n.t('ENUM.NoteTypes.CT') },
        { value: 'F', name: i18n.t('ENUM.NoteTypes.DF') },
        { value: 'G', name: i18n.t('ENUM.NoteTypes.FC') },
        { value: 'H', name: i18n.t('ENUM.NoteTypes.SP') }
    ],
    Therapist: [
        { value: 'A', name: i18n.t('ENUM.Therapist.DB') },
        { value: 'B', name: i18n.t('ENUM.Therapist.DBr') },
        { value: 'C', name: i18n.t('ENUM.Therapist.DD') },
        { value: 'D', name: i18n.t('ENUM.Therapist.DJ') }
    ],
    NoteStatus: [
        { value: 0, name: i18n.t('Shared.All') },
        { value: 1, name: i18n.t('Shared.Pending') },
        { value: 2, name: i18n.t('employee.NeedCosigner') },
        { value: 3, name: i18n.t('Shared.Finalized') }
    ],
    NoteStatusCNR: [
        { value: '1', name: i18n.t('Shared.Pending') },
        { value: '2', name: i18n.t('employee.NeedCosigner') },
        { value: '3', name: i18n.t('Shared.Finalized') }
    ],
    PatientPortalNoteStatus: [
        { value: null, name: i18n.t('Shared.All') },
        { value: 'New', name: i18n.t('Shared.New') },
        { value: 'Completed', name: i18n.t('Shared.Completed') }
    ],
    StatusGroupNotes: [
        { value: '', name: i18n.t('Shared.All') },
        { value: 'N', name: i18n.t('Shared.New') },
        { value: 'P', name: i18n.t('Shared.Pending') },
        { value: 'F', name: i18n.t('Shared.Finalized') }
    ],

    SchedulerDashboardNoteStatus: [
        //{value:i18n.t('Shared.All'),name:'<ALL>'},
        { value: 'NoNotes', name: i18n.t('Shared.NoNotes') },
        { value: 'PendingNotes', name: i18n.t('ENUM.ScheDashNoteStatus.PendingNotes') },
        { value: 'PendingGroupNotes', name: i18n.t('ENUM.ScheDashNoteStatus.PendingGroupNotes') },
        { value: 'PendingCosignNotes', name: i18n.t('ENUM.ScheDashNoteStatus.PendingCosignNotes') },
        { value: 'FinalizedNotes', name: i18n.t('ENUM.ScheDashNoteStatus.FinalizedNotes') }
    ],

    SchedulerDashboardApptStatus: [
        //{value:i18n.t('Shared.All'),name:'<ALL>'},
        { value: 'New', name: i18n.t('Shared.New') },
        { value: 'Confirmed', name: i18n.t('Shared.Confirmed') },
        { value: 'Showed Up', name: i18n.t('Shared.ShowedUp') },
        { value: 'Missed', name: i18n.t('Shared.Missed') }
    ],

    ReportClinicalNotesActions: [
        { value: 'EXPPDFPAT', name: i18n.t('Shared.EXPPDFPAT') },
        { value: 'EXPPDFNOT', name: i18n.t('ENUM.RepCliNotesAct.EXPPDFNOT') },
        { value: 'EXPPDFDAT', name: i18n.t('ENUM.RepCliNotesAct.EXPPDFDAT') }
    ],

    ReportClinicalNotesSortOrder: [
        { value: 'DATE_TIME_PATIENTCODE_THERAPISTSCODE', name: i18n.t('ENUM.ReporSort.A') },
        { value: 'DATE_TIME_THERAPISTCODE_PATIENTCODE', name: i18n.t('ENUM.ReporSort.B') },
        { value: 'PATIENTCODE_DATE_TIME_THERAPISTCODE', name: i18n.t('ENUM.ReporSort.C') },
        { value: 'PATIENTCODE_THERAPISTCODE_DATE_TIME', name: i18n.t('ENUM.ReporSort.D') },
        { value: 'THERAPISTCODE_DATE_TIME_PATIENTCODE', name: i18n.t('ENUM.ReporSort.E') },
        { value: 'THERAPISTCODE_PATIENTCODE_DATE_TIME', name: i18n.t('ENUM.ReporSort.F') },
        { value: 'DATEDESC_TIMEDESC_PATIENTCODE_THERAPISTCODE', name: i18n.t('ENUM.ReporSort.G') },
        { value: 'DATEDESC_TIMEDESC_THERAPISTCODE_PATIENTCODE', name: i18n.t('ENUM.ReporSort.H') },
        { value: 'PATIENTCODE_DATEDESC_TIMEDESC_THERAPISTCODE', name: i18n.t('ENUM.ReporSort.I') },
        { value: 'PATIENTCODE_THERAPISTCODE_DATEDESC_TIMEDESC', name: i18n.t('ENUM.ReporSort.J') },
        { value: 'THERAPISTCODE_DATEDESC_TIMEDESC_PATIENTCODE', name: i18n.t('ENUM.ReporSort.K') },
        { value: 'THERAPISTCODE_PATIENTCODE_DATEDESC_TIMEDESC', name: i18n.t('ENUM.ReporSort.L') },
        { value: 'DATE_TIME_PATIENTLASTNAME_THERAPISTSCODE', name: i18n.t('ENUM.ReporSort.M') }
    ],

    ReportEmployeeCaseLoadSortOrder: [
        { value: 'DATE_TIME_THERAPISTSCODE', name: i18n.t('ENUM.RepEmplSort.A') },
        { value: 'THERAPISTCODE_DATE_TIME', name: i18n.t('ENUM.RepEmplSort.B') },
        { value: 'DATEDESC_TIMEDESC_THERAPISTCODE', name: i18n.t('ENUM.RepEmplSort.C') },
        { value: 'THERAPISTCODE_DATEDESC_TIMEDESC', name: i18n.t('ENUM.RepEmplSort.D') }
    ],

    Characterts: [
        { value: 'Sharp', name: i18n.t('ENUM.Characterts.Sharp') },
        { value: 'Dull', name: i18n.t('ENUM.Characterts.Dull') },
        { value: 'Stabbing', name: i18n.t('ENUM.Characterts.Stabbing') },
        { value: 'Burning', name: i18n.t('ENUM.Characterts.Burning') },
        { value: 'Crushing', name: i18n.t('ENUM.Characterts.Crushing') },
        { value: 'Deep', name: i18n.t('ENUM.Characterts.Deep') },
        { value: 'Sore', name: i18n.t('ENUM.Characterts.Sore') },
        { value: 'Aching', name: i18n.t('ENUM.Characterts.Aching') },
        { value: 'Colic', name: i18n.t('ENUM.Characterts.Colic') },
        { value: 'Throbbing', name: i18n.t('ENUM.Characterts.Throbbing') },
        { value: 'Numb', name: i18n.t('ENUM.Characterts.Numb') },
        { value: 'Shooting', name: i18n.t('ENUM.Characterts.Shooting') },
        { value: 'Pressing', name: i18n.t('ENUM.Characterts.Pressing') },
        { value: 'Tight', name: i18n.t('ENUM.Characterts.Tight') },
        { value: 'Pulling', name: i18n.t('ENUM.Characterts.Pulling') },
        { value: 'Squeezing', name: i18n.t('ENUM.Characterts.Squeezing') }
    ],
    Frequencys: [
        { value: 'Constant', name: i18n.t('ENUM.Frequencys.Constant') },
        { value: 'Intermittent', name: i18n.t('ENUM.Frequencys.Intermittent') }
    ],
    Interventions: [
        i18n.t('ENUM.Interv.Heatpacks'),
        i18n.t('ENUM.Interv.Coldpacks'),
        i18n.t('ENUM.Interv.RepTurning'),
        i18n.t('ENUM.Interv.Ambulation'),
        i18n.t('ENUM.Interv.RelExercises'),
        i18n.t('ENUM.Interv.DeepBreathing'),
        i18n.t('ENUM.Interv.RhyBreathing'),
        i18n.t('ENUM.Interv.Medication')
    ],

    /*Enums for Vitals Signs*/
    TempMethod: [
        { value: 'AXILLARY', name: i18n.t('ENUM.TempMethod.AXILLARY') },
        { value: 'GROIN', name: i18n.t('ENUM.TempMethod.GROIN') },
        { value: 'NOSE', name: i18n.t('ENUM.TempMethod.NOSE') },
        { value: 'OESOPHAGUS', name: i18n.t('ENUM.TempMethod.OESOPHAGUS') },
        { value: 'ORAL', name: i18n.t('ENUM.TempMethod.ORAL') },
        { value: 'PULMONARY ARTERY', name: i18n.t('ENUM.TempMethod.PULMONARYARTERY') },
        { value: 'RECTAL', name: i18n.t('ENUM.TempMethod.RECTAL') },
        { value: 'SKIN SURFACE', name: i18n.t('ENUM.TempMethod.SKINSURFACE') },
        { value: 'TEMPORAL', name: i18n.t('ENUM.TempMethod.TEMPORAL') },
        { value: 'TRACHEA', name: i18n.t('ENUM.TempMethod.TRACHEA') },
        { value: 'TYMPANIC', name: i18n.t('ENUM.TempMethod.TYMPANIC') },
        { value: 'URINARY BLADDER', name: i18n.t('ENUM.TempMethod.URINARYBLADDER') },
        { value: 'URINE', name: i18n.t('ENUM.TempMethod.URINE') }
    ],

    NotificationType:[
        { value: 'EMAIL', name: 'EMAIL' },
        { value: 'TEXT', name: 'TEXT' },
    ],

    IncidentReportHeaderOutComeList:[
        { code: 'Substantiated', description: i18n.t('ENUM.IncidentReportHeaderOutCome.Substantiated') },
        { code: 'Unsubstantiated', description: i18n.t('ENUM.IncidentReportHeaderOutCome.Unsubstantiated') },
        { code: 'Unable to Verify', description: i18n.t('ENUM.IncidentReportHeaderOutCome.UnabletoVerify') }
    ],

    NotificationStatus:[
        { value: 'SUCCESSFUL', name: 'SUCCESSFUL' },
        { value: 'FAILURE', name: 'FAILURE' },
    ],

    Position: [
        { value: 'STANDING', name: i18n.t('ENUM.Position.STANDING') },
        { value: 'SITTING', name: i18n.t('ENUM.Position.SITTING') },
        { value: 'SUPINE', name: i18n.t('ENUM.Position.SUPINE') }
    ],

    ClinicalMedicationRxStatus: [
        { value: 'Active', name: i18n.t('Shared.Active') },
        { value: 'Inactive', name: i18n.t('Shared.Inactive') },
        { value: 'Past', name: i18n.t('Shared.Past') },
        { value: 'Void', name: i18n.t('Shared.Void') }
    ],

    ClinicalMedicationOrderStatus: [
        { value: 'Active', name: i18n.t('Shared.Active') },
        { value: 'Inactive', name: i18n.t('Shared.Inactive') },
        { value: 'Void', name: i18n.t('Shared.Void') }
    ],

    IncidentStatusOptions: [
        { value: 'all', name: i18n.t('Shared.All') },
        { value: 'Finalized', name: i18n.t('Shared.Finalized') },
        { value: 'CompletedDraft', name: i18n.t('Incident.IncCompleteDraft') },
        { value: 'Incomplete', name: i18n.t('Shared.Incomplete') },
        { value: 'Voided', name: i18n.t('Shared.IconDescVN') }
    ],

    IncidentStatusOptionsModalReport: [
        { value: 'all', name: i18n.t('Shared.All') },
        { value: 'Finalized', name: i18n.t('Shared.Finalized') },
        { value: 'CompletedDraft', name: i18n.t('Incident.IncCompleteDraft') },
        { value: 'Incomplete', name: i18n.t('Shared.Incomplete') },
        { value: 'Voided', name: i18n.t('Shared.IconDescVN') }
    ],

    ClinicalMedicationUsage: [
        { value: 'Internal', name: i18n.t('ENUM.CliMedicUsage.Internal') },
        { value: 'Home', name: i18n.t('ENUM.CliMedicUsage.Home') }
    ],

    SchedulerStatus: [
        { value: 'All', name: i18n.t('Shared.All') },
        { value: 'Confirmed', name: i18n.t('Shared.Confirmed') },
        { value: 'NotConfirmed', name: i18n.t('schedulerDailyRep.NoConfirmed') },
        { value: 'ShowedUp', name: i18n.t('Shared.ShowedUp') },
        { value: 'NotShowedUp', name: i18n.t('schedulerDailyRep.NoShow') },
        { value: 'Cancelled', name: i18n.t('ENUM.ScheDashShow.Cancelled') }
    ],
    Location: [
        { value: 'APICAL', name: i18n.t('ENUM.Location.APICAL') },
        { value: 'BRACHIAL', name: i18n.t('ENUM.Location.BRACHIAL') },
        { value: 'CAROTID', name: i18n.t('ENUM.Location.CAROTID') },
        { value: 'DORSALIS', name: i18n.t('ENUM.Location.DORSALIS') },
        { value: 'FEMORAL', name: i18n.t('ENUM.Location.FEMORAL') },
        { value: 'POPTEAL', name: i18n.t('ENUM.Location.POPTEAL') },
        { value: 'POSTENOR TIBIALIS', name: i18n.t('ENUM.Location.POSTENORTIBIALIS') },
        { value: 'RADIAL', name: i18n.t('ENUM.Location.RADIAL') },
        { value: 'SUBCLAVIAN', name: i18n.t('ENUM.Location.SUBCLAVIAN') },
        { value: 'ULNAR', name: i18n.t('ENUM.Location.ULNAR') }
    ],
    CuffLocation: [
        { value: 'RIGHT ARM', name: i18n.t('ENUM.CuffLocation.RIGHTARM') },
        { value: 'LEFT ARM', name: i18n.t('ENUM.CuffLocation.LEFTARM') },
        { value: 'RIGH LEG', name: i18n.t('ENUM.CuffLocation.RIGHLEG') },
        { value: 'LEFT LEG', name: i18n.t('ENUM.CuffLocation.LEFTLEG') }
    ],
    O2Delivery: [
        { value: 'NASAL CANULA', name: i18n.t('ENUM.O2Delivery.NASALCANULA') },
        { value: 'FACE MASK', name: i18n.t('ENUM.O2Delivery.FACEMASK') }
    ],

    // Insurance List
    StatusInsurance: [
        { value: 'A', name: i18n.t('Shared.Active') },
        { value: 'I', name: i18n.t('Shared.Inactive') },
        { value: '', name: i18n.t('Shared.All') }
    ],

    IncidentItems: [
        { value: 'incident-report', text: i18n.t('Incident.IncList') },
        { value: 'incident-dashboard', text: i18n.t('ENUM.IncItems.incDashboard') },
        { value: 'incident-report-general-info', text: i18n.t('ENUM.IncItems.incRepGeneralInf') },
        { value: 'incident-categories', text: i18n.t('ClinicalNotes.CATEGORIES') },
        { value: 'incident-involved', text: i18n.t('ENUM.IncItems.incInvolved') },
        { value: 'incident-participants', text: i18n.t('ENUM.IncItems.incParticipants') }
    ],

    IncidentWorkflowStatusOptions: [
        { value: 'all', name: i18n.t('Shared.All') },
        { value: 'pending', name: i18n.t('Shared.Pending') },
        { value: 'completed', name: i18n.t('Shared.Completed') },
        { value: 'started', name: i18n.t('Shared.Started') },
        { value: 'new', name: i18n.t('Shared.New') },
        { value: 'voided', name: i18n.t('Shared.IconDescVN') }
    ],

    IncidentWorkflowNotesStatusOptions: [
        { value: 'all', name: i18n.t('Shared.All') },
        { value: 'pending', name: i18n.t('Shared.Pending') },
        { value: 'completed', name: i18n.t('Shared.Completed') },
        { value: 'started', name: i18n.t('Shared.Started') },
        { value: 'new', name: i18n.t('Shared.New') }
    ],

    AppointmentsStatus: [
        { value: 'Confirmed', name: i18n.t('Shared.Confirmed') },
        { value: 'NotConfirmed', name: i18n.t('schedulerDailyRep.NoConfirmed') },
        { value: 'Cancelled', name: i18n.t('ENUM.ScheDashShow.Cancelled') },
        { value: 'NotCancelled', name: i18n.t('ENUM.ScheDashShow.NotCancelled') },
        { value: 'ShowedUp', name: i18n.t('Shared.ShowedUp') },
        { value: 'NotShowedUp', name: i18n.t('ENUM.ScheDashShow.NotShowedUp') }
    ],

    ChartReviewViewType: [
        { value: 'NoteType', text: i18n.t('Shared.NoteType') },
        { value: 'Date', text: i18n.t('Shared.Date') }
    ],

    AdmissionsStatusOptions: [
        { value: 'all', name: i18n.t('Shared.All') },
        { value: 'ACTIVE', name: i18n.t('Shared.Active') },
        { value: 'TRANSFER', name: i18n.t('transfer.Transfers') },
        { value: 'INACTIVE', name: i18n.t('Shared.Inactive') }
    ],

    PatientAlertListStatus: [
        { value: 'Y', text: i18n.t('Shared.Active'), selected: true },
        { value: 'N', text: i18n.t('Shared.Inactive'), selected: false },
        { value: null, text: i18n.t('Shared.All'), selected: false }
    ],

    Months: [
        { value: '1', name: i18n.t('Layout.dMonth.January') },
        { value: '2', name: i18n.t('Layout.dMonth.February') },
        { value: '3', name: i18n.t('Layout.dMonth.March') },
        { value: '4', name: i18n.t('Layout.dMonth.April') },
        { value: '5', name: i18n.t('Layout.dMonth.May') },
        { value: '6', name: i18n.t('Layout.dMonth.June') },
        { value: '7', name: i18n.t('Layout.dMonth.July') },
        { value: '8', name: i18n.t('Layout.dMonth.August') },
        { value: '9', name: i18n.t('Layout.dMonth.September') },
        { value: '10', name: i18n.t('Layout.dMonth.October') },
        { value: '11', name: i18n.t('Layout.dMonth.November') },
        { value: '12', name: i18n.t('Layout.dMonth.December') }
    ],

    MarsMode: [
        //  { value: 'all', name: i18n.t('Shared.All') },
        { value: 'Timed', name: 'Timed' },
        { value: 'PRN', name: 'PRN' },
        { value: 'STAT', name: 'STAT' }
    ],

    MarsAdministrationStatus: [
        { value: '1_OVER_DUE', name: '1_OVER_DUE' },
        { value: '2_CLOSE_TO_ADM', name: '2_CLOSE_TO_ADM' },
        { value: '3_PRIOR_TO_ADM', name: '3_PRIOR_TO_ADM' },
        { value: '4_NO_PEND_ADM', name: '4_NO_PEND_ADM' }
    ],

    MarsGivenStatus: [
        { value: 'Given', name: i18n.t('modalMarsMed.Given') },
        { value: 'No Given', name: i18n.t('modalMarsMed.NoGiven') },
        { value: 'Pending to Give', name: i18n.t('modalMarsMed.PenGiven') }
    ],

    ChartReviewTypeToIncludeList: [
        { value: 'DOCUMENTS', text: i18n.t('Shared.Documents') },
        { value: 'CLINICALNOTES', text: i18n.t('Shared.ClinicalNotes') },
        { value: 'DAILYNOTES', text: i18n.t('Shared.DailyNotes') },
        { value: 'ACTIVITIES', text: i18n.t('Shared.Activities') },
        { value: 'LOGNOTES', text: i18n.t('Shared.LogNotesTitle') },
        { value: 'TREATMENTPLANS', text: i18n.t('Shared.treatmentplan') },
        { value: 'ASAM', text: i18n.t('Shared.ASAM') }
    ],

    AuditModuleTypeList: [
        { value: 'Authentication', text: i18n.t('AuditList.AUTHENTICATION').toUpperCase() },
        { value: 'Clinical Notes', text: i18n.t('Shared.ClinicalNotesHeader').toUpperCase() },
        { value: 'Patient Info', text: i18n.t('Shared.PatientInformationHeader').toUpperCase() },
        { value: 'Activities', text: i18n.t('Shared.ActivitiesHeader').toUpperCase() },
        { value: 'Alerts', text: i18n.t('Shared.Alerts').toUpperCase() },
        { value: 'Allergies', text: i18n.t('Shared.PatientAllergies').toUpperCase() },
        { value: 'Mars Alerts', text: i18n.t('Shared.PatientMarsAlerts').toUpperCase() },
        { value: 'Patient Contacts', text: i18n.tc('Shared.PatientContact', 2).toUpperCase() },
        { value: 'Documents', text: i18n.tc('Shared.PatientDoc', 2).toUpperCase() },
        { value: 'Log Notes', text: i18n.t('Shared.LogNotes').toUpperCase() },
        { value: 'Daily Notes', text: i18n.t('Shared.DailyNotes').toUpperCase() },
        {
            value: 'Special Precautions',
            text: i18n.t('Shared.PatientSpecialPrecautions').toUpperCase()
        },
        { value: 'Insurances', text: i18n.t('Shared.PatientInsurance').toUpperCase() },
        { value: 'Vital Signs', text: i18n.t('Shared.ClinicalVitalSign').toUpperCase() },
        { value: 'Transfer', text: i18n.t('Shared.Transfer').toUpperCase() },
        { value: 'Admission', text: i18n.t('Shared.Admission').toUpperCase() },
        { value: 'Discharge', text: i18n.t('Shared.DischargesHeader').toUpperCase() },
        { value: 'Diagnosis', text: i18n.t('Shared.Diagnoses').toUpperCase() },
        { value: 'Medications', text: i18n.t('Shared.Medications').toUpperCase() },
        { value: 'Treatment Plan', text: i18n.t('Shared.TP').toUpperCase() },
        { value: 'Scheduler', text: i18n.t('Shared.Appointments').toUpperCase() },
        { value: 'Group Notes', text: i18n.t('Shared.GroupNotes').toUpperCase() },
        { value: 'Mars', text: i18n.t('Shared.MARS').toUpperCase() },
        { value: 'Audit Settings', text: i18n.t('Shared.AuditSettingsTitle').toUpperCase() },
        { value: 'Incidents', text: i18n.t('AuditList.INCIDENTS').toUpperCase() }
    ],
    AuditActionTypeList: [
        { value: 'WAA_LOGIN', text: i18n.t('Shared.LoginTitle').toUpperCase() },
        { value: 'WAA_LOGOUT', text: i18n.t('Shared.LogOut').toUpperCase() },
        { value: 'WAA_INSERT', text: i18n.t('Shared.Add').toUpperCase() },
        { value: 'WAA_UPDATE', text: i18n.t('AuditList.UPDATE').toUpperCase() },
        { value: 'WAA_DELETE', text: i18n.t('Shared.TitleDelete').toUpperCase() },
        { value: 'WAA_UNAUTHORIZED', text: i18n.t('AuditList.UNAUTHORIZED').toUpperCase() },
        { value: 'WAA_VIEW', text: i18n.t('Shared.View').toUpperCase() }
    ],

    MedicationStatusReport: [
        { value: 'ALL', text: i18n.t('Shared.All') },
        { value: 'ACTIVE', text: i18n.t('Shared.Active') },
        { value: 'INACTIVE', text: i18n.t('Shared.Inactive') }
    ],

    ActionCodeApptEnum: Object.freeze({
        AC_SHOWUP: 0,
        AC_UNDO_SHOWUP: 1
    }),

    PasswordListStatus: [
        { value: true, text: i18n.t('Shared.Active'), selected: true },
        { value: false, text: i18n.t('Shared.Expired'), selected: false },
        { value: 'All', text: i18n.t('Shared.All'), selected: false }
    ],

    StatusClaimList: [
        //  {value:'All',name: i18n.t('Shared.All')},
        { value: 'HIDEVOID', name: i18n.t('PatientClaimList.HideVoid') },
        { value: 'HIDEZEROBALANCE', name: i18n.t('Shared.HZBalance') }
    ],

    MedicationInboxSatusBPIList: [
        { value: 'Ordered', name: 'ORDERED' },
        { value: 'Received', name: 'RECEIVED' },
        { value: 'Marscreated', name: 'MARSCREATED' }
    ],

    MedicationInboxSatusList: [
        { value: 'Ordered', name: i18n.t('Shared.Ordered') },
        { value: 'Received', name: i18n.t('Shared.Received') },
        { value: 'Marscreated', name: i18n.t('Medication.internalStatus.MARSCREATED') },
        { value: 'Pending', name: i18n.t('Shared.Pending') },
        { value: 'Partiallyfilled', name: i18n.t('Shared.PartiallyFilled') },
        { value: 'Unabletofill', name: i18n.t('Shared.UnableToFill') },
        { value: 'Filled', name: i18n.t('Shared.Filled') },
        { value: 'Validated', name: i18n.t('Shared.Validated') },
        { value: 'Partiallygiven', name: i18n.t('Shared.PartiallyGiven') },
        { value: 'Fullygiven', name: i18n.t('Shared.FullyGiven') },
        { value: 'Voided', name: i18n.t('Shared.IconDescVN') }
    ],

    MedicatioInboxRxStatus: [
        { value: 'Active', name: i18n.t('Shared.Active') },
        { value: 'Inactive', name: i18n.t('Shared.Inactive') },
        { value: 'Past', name: i18n.t('Shared.Past') },
        { value: 'Void', name: i18n.t('Shared.Void') }
    ],

    DrugOrdersInboxStatus: [
        { value: null, name: i18n.t('Shared.All') },
        { value: 'ORDERED', name: i18n.t('Shared.Ordered') },
        { value: 'PENDING', name: i18n.t('Shared.Pending') },
        { value: 'PARTIALLYFILLED', name: i18n.t('Shared.PartiallyFilled') },
        { value: 'UNABLETOFILL', name: i18n.t('Shared.UnableToFill') },
        { value: 'FILLED', name: i18n.t('Shared.Filled') },
        { value: 'VALIDATED', name: i18n.t('Shared.Validated') },
        { value: 'AUTOVALIDATED', name: i18n.t('Medication.internalStatus.AUTOVALIDATED') },
        { value: 'RECEIVED', name: i18n.t('Shared.Received') },
        { value: 'MARSCREATED', name: i18n.t('Medication.internalStatus.MARSCREATED') },
        { value: 'PARTIALLYGIVEN', name: i18n.t('Shared.PartiallyGiven') },
        { value: 'FULLYGIVEN', name: i18n.t('Shared.FullyGiven') },
        { value: 'VOIDED', name: i18n.t('Shared.IconDescVN') }
    ],

    DrugOrdersInboxType: [
        { value: null, name: i18n.t('Shared.All') },
        { value: false, name: i18n.t('Shared.Outpatient') },
        { value: true, name: i18n.t('Shared.Inpatient') }
    ],

    DrugOrdersInboxUsage: [
        { value: null, name: i18n.t('Shared.All') },
        { value: true, name: i18n.t('ENUM.CliMedicUsage.Internal') },
        { value: false, name: i18n.t('ENUM.CliMedicUsage.Home') }
    ],

    DrugOrdersInboxItems: [
        {
            ReadOnly: true,
            value: 'Settopending',
            text: i18n.t('DrugOrdersInboxRightBar.Settopending')
        },
        {
            ReadOnly: true,
            value: 'Addingnotes',
            text: i18n.t('DrugOrdersInboxRightBar.Addingnotes')
        },
        {
            ReadOnly: true,
            value: 'Settoordered',
            text: i18n.t('DrugOrdersInboxRightBar.Settoordered')
        },
        {
            ReadOnly: true,
            value: 'Settounabletofill',
            text: i18n.t('DrugOrdersInboxRightBar.Settounabletofill')
        },
        { ReadOnly: true, value: 'Fillorder', text: i18n.t('DrugOrdersInboxRightBar.Fillorder') },
        {
            ReadOnly: true,
            value: 'Undofillorders',
            text: i18n.t('DrugOrdersInboxRightBar.Undofillorders')
        },
        { ReadOnly: true, value: 'Settovalid', text: i18n.t('DrugOrdersInboxRightBar.Settovalid') },
        {
            ReadOnly: true,
            value: 'Undovalidated',
            text: i18n.t('DrugOrdersInboxRightBar.Undovalidated')
        },
        {
            ReadOnly: true,
            value: 'Returneditems',
            text: i18n.t('Shared.ReturnItems')
        },
        {
            ReadOnly: true,
            value: 'Printmedlabels',
            text: i18n.t('Shared.Printmedlabels')
        },
        {
            ReadOnly: true,
            value: 'Patientinformation',
            text: i18n.t('DrugOrdersInboxRightBar.Patientinformation')
        },
        //{ReadOnly:true,value:'Prescription',text: i18n.t('DrugOrdersInboxRightBar.Prescription')},
        //{ReadOnly:true,value:'Printmedicationhistory',text: i18n.t('Shared.Printmedicationhistory')},
        {
            ReadOnly: true,
            value: 'DrugInboxAllergies',
            text: i18n.t('DrugOrdersInboxRightBar.Allergies')
        },
        {
            ReadOnly: true,
            value: 'FormularyStatus',
            text: i18n.t('DrugOrdersInboxRightBar.FormularyStatus')
        },
        {
            ReadOnly: false,
            value: 'Druginformation',
            text: i18n.t('Shared.DrugInfo')
        },
        {
            ReadOnly: true,
            value: 'SetToChargeable',
            text: i18n.t('DrugOrdersInboxRightBar.SetToChargeable')
        },
        {
            ReadOnly: true,
            value: 'UndoSetToChargeable',
            text: i18n.t('DrugOrdersInboxRightBar.UndoSetToChargeable')
        },
        {
            ReadOnly: true,
            value: 'Viewmedicationhistory',
            text: i18n.t('DrugOrdersInboxRightBar.Viewmedicationhistory')
        },
        {
            ReadOnly: false,
            value: 'DrugInteraction',
            text: i18n.t('DrugOrdersInboxRightBar.DrugInteraction')
        },
        { ReadOnly: false, value: 'DrugAssist', text: i18n.t('DrugOrdersInboxRightBar.DrugAssist') }
    ],

    DrugOrderItemsShowLots: [
        { value: 0, name: i18n.t('Shared.All') },
        { value: 1, name: i18n.t('Shared.Expired') }
    ],

    InjectionAssessmentInjectionSites: [
        { value: 'Right Deltoid', name: 'Right Deltoid' },
        { value: 'Left Deltoid', name: 'Left Deltoid' },
        { value: 'Right Gluteal', name: 'Right Gluteal' },
        { value: 'Left Gluteal', name: 'Left Gluteal' },
        { value: 'Right Lower Abdomen', name: 'Right Lower Abdomen' },
        { value: 'Left Lower Abdomen', name: 'Left Lower Abdomen' },
        { value: 'Right Upper Abdomen', name: 'Right Upper Abdomen' },
        { value: 'Left Upper Abdomen', name: 'Left Upper Abdomen' },
        { value: 'Right Thigh', name: 'Right Thigh' },
        { value: 'Left Thigh', name: 'Left Thigh' },
        { value: 'Right Upper Arm', name: 'Right Upper Arm' },
        { value: 'Left Upper Arm', name: 'Left Upper Arm' }
    ],

    DrugOrderTypeNote: [
        { value: '', name: '' },
        {
            value: i18n.t('PharmacyNotes.NoteType.Antibiotic'),
            name: i18n.t('PharmacyNotes.NoteType.Antibiotic')
        },
        {
            value: i18n.t('PharmacyNotes.NoteType.Discontinue'),
            name: i18n.t('PharmacyNotes.NoteType.Discontinue')
        },
        {
            value: i18n.t('PharmacyNotes.NoteType.contraindication'),
            name: i18n.t('PharmacyNotes.NoteType.contraindication')
        },
        {
            value: i18n.t('PharmacyNotes.NoteType.Monitoring'),
            name: i18n.t('PharmacyNotes.NoteType.Monitoring')
        },
        {
            value: i18n.t('PharmacyNotes.NoteType.DrugDisease'),
            name: i18n.t('PharmacyNotes.NoteType.DrugDisease')
        },
        {
            value: i18n.t('PharmacyNotes.NoteType.DrugInteraction'),
            name: i18n.t('PharmacyNotes.NoteType.DrugInteraction')
        },
        {
            value: i18n.t('PharmacyNotes.NoteType.Formulary'),
            name: i18n.t('PharmacyNotes.NoteType.Formulary')
        },
        {
            value: i18n.t('PharmacyNotes.NoteType.Allergy'),
            name: i18n.t('PharmacyNotes.NoteType.Allergy')
        },
        {
            value: i18n.t('PharmacyNotes.NoteType.Reconciliation'),
            name: i18n.t('PharmacyNotes.NoteType.Reconciliation')
        },
        {
            value: i18n.t('PharmacyNotes.NoteType.OptimizeDose'),
            name: i18n.t('PharmacyNotes.NoteType.OptimizeDose')
        },
        {
            value: i18n.t('PharmacyNotes.NoteType.OptimizeDrug'),
            name: i18n.t('PharmacyNotes.NoteType.OptimizeDrug')
        },
        {
            value: i18n.t('PharmacyNotes.NoteType.OptimizeDuration'),
            name: i18n.t('PharmacyNotes.NoteType.OptimizeDuration')
        },
        {
            value: i18n.t('Shared.Other'),
            name: i18n.t('Shared.Other')
        },
        {
            value: i18n.t('PharmacyNotes.NoteType.Pharmacotherapy'),
            name: i18n.t('PharmacyNotes.NoteType.Pharmacotherapy')
        },
        {
            value: i18n.t('PharmacyNotes.NoteType.Review'),
            name: i18n.t('PharmacyNotes.NoteType.Review')
        },
        {
            value: i18n.t('PharmacyNotes.NoteType.Therapeutic'),
            name: i18n.t('PharmacyNotes.NoteType.Therapeutic')
        },
        {
            value: i18n.t('PharmacyNotes.NoteType.Untreated'),
            name: i18n.t('PharmacyNotes.NoteType.Untreated')
        },
        {
            value: i18n.t('PharmacyNotes.NoteType.Wrong'),
            name: i18n.t('PharmacyNotes.NoteType.Wrong')
        }
    ],

    StatusOptions: [
        { value: 'A', text: i18n.t('Shared.Active'), selected: true },
        { value: 'I', text: i18n.t('Shared.Inactive'), selected: false }
    ],

    UAEProductTypeSelectList: [
        { value: 'CD', text: 'CS-CD' },
        { value: 'SCD', text: 'CS-SCD' },
        { value: 'C', text: 'CS-C' },
        { value: 'G', text: i18n.t('Shared.General') },
        { value: 'O', text: i18n.t('Shared.OvConunter') }
    ],

    DrugUsage: [
        { value: 'A', text: i18n.t('Shared.All') },
        { value: 'I', text: i18n.t('ENUM.CliMedicUsage.Internal') },
        { value: 'H', text: i18n.t('ENUM.CliMedicUsage.Home') }
    ],

    CosignerList: [
        { text: i18n.t('insuranceSetup.oPList.n'), value: 'N' },
        { text: i18n.t('employee.NeedCosigner'), value: 'Y' },
        { text: i18n.t('employee.IsCosigner'), value: 'C' }
    ],

    EmployeeStatus: [
        { text: i18n.t('Shared.Active'), value: 'A' },
        { text: i18n.t('employee.Terminated'), value: 'T' }
    ],

    EmployeeProgramType: [
        { text: i18n.t('employee.MProgram'), value: 'Y' },
        { text: i18n.t('employee.OProgram'), value: 'N' }
    ],
    PatientClaimAttendanceOptions: [
        { value: 1, text: i18n.t('ENUM.PatientClaimAttendance.DeleteAttendanceRecords') },
        { value: 2, text: i18n.t('ENUM.PatientClaimAttendance.UncheckBilledAttendance') }
    ],
    TestOrderPriority: [
        { value: 'ROUTINE', text: i18n.t('TestOrder.Routine') },
        { value: 'STAT', text: i18n.t('TestOrder.Stat') }
    ],
    TestOrderResultType: [
        { value: 'Normal', text: i18n.t('TestOrder.ResultType.Normal') },
        { value: 'Abnormal', text: i18n.t('TestOrder.ResultType.Abnormal') },
        { value: 'Critical', text: i18n.t('TestOrder.ResultType.Critical') },
        { value: 'Undefined', text: i18n.t('TestOrder.ResultType.Undefined') }
    ],
    TestOrderTestType: [
        { value: 'Chemistry', text: i18n.t('Shared.Chemistry') },
        { value: 'Coagulation', text: i18n.t('Shared.Coagulation') },
        { value: 'Hematology', text: i18n.t('Shared.Hematology') },
        { value: 'Imaging', text: i18n.t('Shared.Imaging') },
        { value: 'Surgical', text: i18n.t('Shared.Surgical') }
    ],
    ICDVersion: [
        { value: 'ICD9', text: 'ICD9' },
        { value: 'ICD10', text: 'ICD10' }
    ],
    TestOrderStatus: [
        { value: 'ORDERED', name: i18n.t('Shared.Ordered') },
        { value: 'FINALIZED', name: i18n.t('Shared.Finalized') },
        { value: 'SPECIMENRECEIVED', name: i18n.t('TestOrder.InternalStatus.SPECIMENRECEIVED') },
        { value: 'RESULTED', name: i18n.t('TestOrder.InternalStatus.RESULTED') },
        { value: 'UNABLETODO', name: i18n.t('TestOrder.InternalStatus.UNABLETODO') }
    ],
    TestOrderResultCondSpecimen: [
        { value: 'Hemolyzed', name: i18n.t('TestOrder.CondSpecimen.Hemolyzed') }
    ],
    POAOptions: [
        { value: 'Y', text: 'Y' },
        { value: 'N', text: 'N' },
        { value: 'U', text: 'U' },
        { value: 'W', text: 'W' },
        { value: '1', text: '1' }
    ],
    PatientsPortalDashboardItems: [
        {
            ReadOnly: true,
            value: 'PPDB_PatientInfo',
            text: i18n.t('Shared.PatientInformationHeader')
        },
        {
            ReadOnly: true,
            value: 'PPDB_CreateCredentials',
            text: i18n.t('PatientPortalDashboard.RightBar.CreateCredentials')
        },
        {
            ReadOnly: true,
            value: 'PPDB_ChangeUsername',
            text: i18n.t('PatientPortalDashboard.RightBar.ChangeUsername')
        },
        {
            ReadOnly: true,
            value: 'PPDB_ChangePassword',
            text: i18n.t('PatientPortalDashboard.RightBar.ChangePassword')
        },
        {
            ReadOnly: false,
            value: 'PPDB_ChangePatInfo',
            text: i18n.t('PatientPortalDashboard.RightBar.ChangePatInfo')
        },
        {
            ReadOnly: false,
            value: 'PPDB_Messages',
            text: i18n.t('PatientPortalDashboard.RightBar.Messages')
        },
        {
            ReadOnly: true,
            value: 'PPDB_PatientForms',
            text: i18n.t('PatientPortalDashboard.RightBar.PatientForms')
        },
        {
            ReadOnly: true,
            value: 'PPDB_PatientContacts',
            text: i18n.tc('Contact.PatientContact', 2)
        },
        {
            ReadOnly: true,
            value: 'PPDB_PatientClaims',
            text: i18n.t('Shared.Claim')
        }
    ],

    PatientsPortalSummaryItems: [
        {
            ReadOnly: false,
            value: 'PPDB_PatientList',
            text: i18n.t('Shared.PatientList')
        },
        {
            ReadOnly: false,
            value: 'PPDB_Summary',
            text: i18n.t('PatientPortalDashboard.RightBar.Summary')
        },
        {
            ReadOnly: true,
            value: 'PPDB_PatientInfo',
            text: i18n.t('Shared.PatientInformationHeader')
        },
        {
            ReadOnly: true,
            value: 'PPDB_CreateCredentials',
            text: i18n.t('PatientPortalDashboard.RightBar.CreateCredentials')
        },
        /*
        {
            ReadOnly: true,
            value: 'PPDB_CreateAuthLogins',
            text: i18n.t('PatientPortalDashboard.RightBar.CreateAuthLogins')
        },
        {
            ReadOnly: true,
            value: 'PPDB_CreateLogin',
            text: i18n.t('PatientPortalDashboard.RightBar.CreateLogin')
        },
        */
        {
            ReadOnly: true,
            value: 'PPDB_ChangeUsername',
            text: i18n.t('PatientPortalDashboard.RightBar.ChangeUsername')
        },
        {
            ReadOnly: true,
            value: 'PPDB_ChangePassword',
            text: i18n.t('PatientPortalDashboard.RightBar.ChangePassword')
        },
        {
            ReadOnly: false,
            value: 'PPDB_ChangePatInfo',
            text: i18n.t('PatientPortalDashboard.RightBar.ChangePatInfo')
        },
        {
            ReadOnly: false,
            value: 'PPDB_Messages',
            text: i18n.t('PatientPortalDashboard.RightBar.Messages')
        },
        {
            ReadOnly: true,
            value: 'PPDB_PatientForms',
            text: i18n.t('PatientPortalDashboard.RightBar.PatientForms')
        },
        {
            ReadOnly: true,
            value: 'PPDB_PatientContacts',
            text: i18n.tc('Contact.PatientContact', 2)
        },
        {
            ReadOnly: true,
            value: 'PPDB_PatientClaims',
            text: i18n.t('Shared.Claim')
        },
        {
            ReadOnly: true,
            value: 'PPDB_EmailToPatient',
            text: i18n.t('Shared.EmailPatient')
        },
        {
            ReadOnly: true,
            value: 'PPDB_TextToPatient',
            text: i18n.t('Shared.TextPatient')
        }
    ],

    YesNoAllOptions: [
        { value: null, text: i18n.t('Shared.All') },
        { value: true, text: i18n.t('Shared.TitleYes') },
        { value: false, text: 'No' }
    ],

    AccessToPortalOptions: [
        { value: null, text: i18n.t('Shared.All') },
        { value: true, text: i18n.t('PatientPortalDashboard.Enrolled') },
        { value: false, text: i18n.t('PatientPortalDashboard.NotEnrolled') }
    ],

    PatientPortalStatusOptions: [
        { value: null, text: i18n.t('Shared.All') },
        { value: 'NotEnrolled', text: i18n.t('PatientPortalDashboard.NotEnrolled') },
        { value: 'Enrolled', text: i18n.t('PatientPortalDashboard.Enrolled') },
        { value: 'PendingActivation', text: i18n.t('PatientPortalDashboard.PendingActivation') }
    ],

    PatientCensusStatus: [
        { value: 'A', text: 'Active' },
        { value: 'I', text: 'Discharged' }
    ],

    NewReadAllOptions: [
        { value: null, text: i18n.t('Shared.All') },
        { value: 'N', text: i18n.t('Shared.New') },
        { value: 'R', text: i18n.t('EmployeeInbox.StOpts.read') }
    ],

    MedicationAdminTimedPrnMode: [
        { value: 'Timed', name: 'Timed' },
        { value: 'PRN', name: 'PRN' }
    ],

    MedicationAdminStatus: [
        { value: 'Given', text: i18n.t('modalMarsMed.Given') },
        { value: 'GivenLate', text: i18n.t('MedicationAdministration.status.GivenLate') },
        { value: 'PendingToGive', text: i18n.t('modalMarsMed.PenGiven') },
        { value: 'OverDue', text: i18n.t('MedicationAdministration.status.OverDue') },
        { value: 'CloseToAdm', text: i18n.t('MedicationAdministration.status.CloseAdmin') },
        { value: 'PriorToAdm', text: i18n.t('MedicationAdministration.status.PriorAdmin') }
    ],

    AppointmentPreferenceOptions: [
        { value: 'F', text: i18n.t('schedule-editor.Preference.Options.FirstAvailable') },
        { value: 'P', text: i18n.t('schedule-editor.Preference.Options.Preferred') }
    ],

    BlockingTimesStatus: [
        { value: 'A', text: i18n.t('Shared.Allowing') },
        { value: 'B', text: i18n.t('Shared.Blocking') }
    ],

    DaysOfWeek: [
        { value: '1', name: i18n.t('Layout.dDay.Sunday') },
        { value: '2', name: i18n.t('Layout.dDay.Monday') },
        { value: '3', name: i18n.t('Layout.dDay.Tuesday') },
        { value: '4', name: i18n.t('Layout.dDay.Wednesday') },
        { value: '5', name: i18n.t('Layout.dDay.Thursday') },
        { value: '6', name: i18n.t('Layout.dDay.Friday') },
        { value: '7', name: i18n.t('Layout.dDay.Saturday') }
    ],
    PaymentPostStatus: [
        { value: 0, name: i18n.t('Shared.All') },
        { value: 1, name: i18n.t('Shared.Finalized') },
        { value: 2, name: i18n.t('PostPayment.Manual.Draft') }
    ],
    PaymentPostType: [
        { value: 0, name: i18n.t('Shared.All') },
        { value: 1, name: i18n.t('ClaimBatchStatus.patientPayment') },
        { value: 2, name: i18n.t('PostPayment.Manual.InsurancePayment') }
    ],
    PaymentPostPaymentType: [
        { value: 0, name: i18n.t('Shared.All') },
        { value: 1, name: i18n.t('PostPayment.Manual.Check') },
        { value: 2, name: i18n.t('PostPayment.Manual.CRCard') },
        { value: 3, name: i18n.t('PostPayment.Manual.Cash') },
        { value: 4, name: i18n.t('Shared.Other') },
        { value: 5, name: 'EFT' }
    ]
});

export default EnumService;
